import get from 'lodash/get';
import set from 'lodash/set';
import { events } from './';

const a = {
	appKey: 'omApp',
	apps: [],
	key: get(global, 'omStaticDataKey', 'app.data'),
	get: (key, fallback) => get(a.data, key, fallback),
	set: (key, value) => set(a.data, key, value),
	setApp: (app, key = a.appKey) => {
		set(a.data, key + '.app', app);
		a.apps.push(key);
		events.trigger('App.init', app);
	},
	getApp: (key = a.appKey) => get(a.data, key + '.app'),
	hasData: () => {
		const keys = Object.keys(a.data).filter((k) => !a.apps.includes(k));
		return 0 < keys.length;
	},
	ready: () => {
		set(global, a.key + '.ready', true);
		events.trigger('App.ready', a);
	},
};
if (!get(global, a.key)) {
	set(global, a.key, {});
}
a.data = get(global, a.key);

export default a;
